export class ExpiryDialogModel {
    constructor(
        public item: Object
    ) {}
  }